import Joi from "joi";

export const ValidadeCourse = (data) => {
  const schema = Joi.object({
    nome: Joi.string().required().messages({
      "string.empty": "(Nome) deve ser informado!",
      "any.required": "(Nome) deve ser informado!",
    }),
  })

  const { error } = schema.validate(data, {
    allowUnknown: true,
  })

  if (error?.details[0]?.message || error?.details[0]?.path[0]) {
    return {
      message: error?.details[0]?.message,
      keyError: error?.details[0]?.path[0]
    }
  }
}
